
import * as JWTDECODE from 'jwt-decode';

export class AuthenticatedUser {

	public decodedToken: any = {};

	public get token(): string { return this._token; };

	constructor(private _token: string) {
		this.decodedToken = JWTDECODE(_token);
	}

	public get name(): string { return this.unique_name; }

	public get fullName(): string { return this.decodedToken.given_name; }

	public get nameid(): string { return this.decodedToken.nameid }

	public get unique_name(): string { return this.decodedToken.unique_name }

	public get roles(): string[] {
		if (this.decodedToken.role instanceof Array) {
			return this.decodedToken.role;
		}

		return [this.decodedToken.role];
	}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/authentication/AuthenticatedUser.ts